import { validateFeatureFlag } from '../../../services/featureFlagService';
import { FEATURE_FLAG } from '../../../constants/general';
import { ICategoryDetails, ITransaction } from '../../../types';
import { ACTION_TYPES, BUSINESS_PERCENT } from '../../categorizeTransacrions/constants';
import { trackMixPanel } from '../../../services/mixpanel.service';

const CATEGORIZATION_TYPES = {
  EXPENSE: 'EXPENSE',
  INCOME: 'INCOME',
};

export const isCategorized = (categoryDetails: ICategoryDetails) : boolean => (categoryDetails?.businessPercent != null);
export const isCategorizedAsBusiness = (categoryDetails: ICategoryDetails) : boolean => isCategorized(categoryDetails) && categoryDetails?.businessPercent > 0;
export const isCategorizedMostlyAsBusiness = (categoryDetails: ICategoryDetails) : boolean => isCategorized(categoryDetails) && categoryDetails?.businessPercent >= 0.5;
export const isCategorizedOnlyAsBusiness = (categoryDetails: ICategoryDetails) : boolean => isCategorized(categoryDetails) && categoryDetails?.businessPercent === 1;
export const isCategorizedAsPersonal = (categoryDetails: ICategoryDetails) : boolean => isCategorized(categoryDetails) && categoryDetails?.businessPercent < 1;
export const isCategorizedMostlyAsPersonal = (categoryDetails: ICategoryDetails) : boolean => isCategorized(categoryDetails) && categoryDetails?.businessPercent < 0.5;
export const isCategorizedOnlyAsPersonal = (categoryDetails: ICategoryDetails) : boolean => isCategorized(categoryDetails) && categoryDetails?.businessPercent === 0;
export const isCategorizedAsSplit = (categoryDetails: ICategoryDetails) : boolean => isCategorizedAsBusiness(categoryDetails) && isCategorizedAsPersonal(categoryDetails);
export const isAllowedToUpdate = (allowCategorizationEnum: string) : boolean => (allowCategorizationEnum === 'READ_WRITE');
export const canUserCategorize = (allowCategorizationEnum: string, categorizationType: string) : boolean => {
  if (isAllowedToUpdate(allowCategorizationEnum) && validateFeatureFlag(FEATURE_FLAG.CATEGORIZATION.FEATURE)) {
    if (categorizationType === CATEGORIZATION_TYPES.EXPENSE) return true;
    if (categorizationType === CATEGORIZATION_TYPES.INCOME && validateFeatureFlag(FEATURE_FLAG.CATEGORIZATION.INCOME)) return true;
  }
  return false;
};
export const canUserCategorizeAsSplit = (categorizationType: string) => (
  categorizationType === CATEGORIZATION_TYPES.EXPENSE && validateFeatureFlag(FEATURE_FLAG.CATEGORIZATION.SPLIT)
);
export const showUserSplitOption = (allowCategorizationEnum: string, categorizationType: string) : boolean => (canUserCategorize(allowCategorizationEnum, categorizationType) && canUserCategorizeAsSplit(categorizationType));
export const getCategoryIdFromTransaction = (transaction: ITransaction) => transaction?.categoryDetails?.categoryExternalId || transaction?.suggestedTaxCategoryId;

export const calculateBusinessPercentAmount = (amount: number, businessPercent: number) => (businessPercent > 0 ? Math.abs(amount) * businessPercent : 0);

export const isCategorizationTypeIncome = (categorizationType: string) => categorizationType === CATEGORIZATION_TYPES.INCOME;

export const areAllRequiredDataReady = (transaction: ITransaction, actionType: string) => {
  if (actionType === ACTION_TYPES.LIFE) return true;
  return (transaction?.categoryDetails?.categoryExternalId || transaction?.suggestedTaxCategoryId);
};

export const getBusinessPercentByActionType = (actionType: string, transaction: ITransaction) => {
  if (actionType === ACTION_TYPES.LIFE) return BUSINESS_PERCENT.LIFE;
  if (actionType === ACTION_TYPES.WORK) return BUSINESS_PERCENT.WORK;
  if (actionType === ACTION_TYPES.CHOOSE_CATEGORY && transaction?.categorizationType === CATEGORIZATION_TYPES.INCOME) return BUSINESS_PERCENT.WORK;
  if (actionType === ACTION_TYPES.SPLIT || actionType === ACTION_TYPES.CHOOSE_CATEGORY) return transaction?.categoryDetails?.businessPercent;
  return BUSINESS_PERCENT.WORK;
};

export const sendCategorizationEventToMixpanel = (transaction: any, categoriesList: any, origin?: string) => {
  const suggestedCategory = transaction?.suggestedTaxCategoryId && categoriesList?.categories.find((category: any) => category.id === transaction?.suggestedTaxCategoryId);
  const selectedCategory = categoriesList?.categories.find((category: any) => category.id === transaction?.categoryDetails.categoryExternalId);
  const categorizationTypeString = transaction?.categorizationType;
  let categorizationTypeFirstCapital = '';
  if (categorizationTypeString) {
    categorizationTypeFirstCapital = categorizationTypeString.charAt(0).toUpperCase() + categorizationTypeString.slice(1).toLowerCase();
  }
  trackMixPanel('Transaction Categorized', {
    categorizationType: categorizationTypeFirstCapital,
    hasSuggestedTaxCategory: transaction?.suggestedTaxCategoryId != null,
    identifier: transaction?.transactionId,
    life: isCategorizedOnlyAsPersonal(transaction?.categoryDetails),
    matchSuggestedTaxCategory: transaction?.suggestedTaxCategoryId === transaction?.categoryDetails.categoryExternalId,
    mostly_life: isCategorizedMostlyAsPersonal(transaction?.categoryDetails) && !isCategorizedOnlyAsPersonal(transaction?.categoryDetails),
    mostly_work: isCategorizedMostlyAsBusiness(transaction?.categoryDetails) && !isCategorizedOnlyAsBusiness(transaction?.categoryDetails),
    Origin: origin || window.location.pathname?.replace('/', '') || 'TransactionDetails',
    selectedFromList: true,
    splitted: isCategorizedAsSplit(transaction?.categoryDetails),
    wasChanged: false,
    work: isCategorizedOnlyAsBusiness(transaction?.categoryDetails),
    'Suggested category': suggestedCategory?.title,
    'Selected category': selectedCategory?.title,
  });
};
